<template>
    <div>
        <div class="select-salons panel panel-default">

            <panel-search @search="search" placeholder="Введите наименование автосалона для поиска"></panel-search>

            <table class="table table-striped" id="result-form-search">
                <thead>
                <tr>
                    <th></th>
                    <th>Салон</th>
                    <th>ФИО супервайзера</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="salon in salons">
                    <td>
                        <input type="checkbox"
                               :id="`id-${salon.id}`"
                               v-model="selected_ids"
                               :value="salon.id"
                        >
                        <label :for="`id-${salon.id}`"><span></span></label>
                    </td>
                    <td>
                        <a :href="`/salons/${salon.id}`">{{ salon.name }}</a>
                    </td>
                    <td>{{ (salon.supervisor) ? salon.supervisor.full_name : '' }}</td>
                </tr>
                <tr v-if="!salons.length">
                    <td colspan="5">Поиск</td>
                </tr>
                </tbody>
            </table>

            <div class="panel-heading">
                <h3>Выбранные салоны</h3>
            </div>
            <table class="table table-striped">
                <thead>
                <tr>
                    <th></th>
                    <th>Салон</th>
                    <th>ФИО супервайзера</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="salon in selected_salons">
                    <td>
                        <input type="checkbox"
                               :id="`id-selected-${salon.id}`"
                               v-model="selected_ids"
                               :value="salon.id"
                               :name="name"
                        >
                        <label :for="`id-selected-${salon.id}`"><span></span></label>
                    </td>
                    <td>
                        <a :href="`/salons/${salon.id}`">{{ salon.name }}</a>
                    </td>
                    <td>{{ (salon.supervisor) ? salon.supervisor.full_name : '' }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="selected-salons">
            Выбрано: <span>{{selected_ids.length}}</span> автосалона
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        props: {
            name: {
                type: String,
                default: 'salons[]',
            },
            selected: {
                type: Array,
                default: [],
            },
        },
        data(){
            return {
                salons: [],
                selected_ids: _.map(this.selected, 'id'),
                selected_salons: this.selected,
            }
        },
        asyncComputed: {
            salons() {
                return axios
                    .get('/api/salons', {
                        params: {
                            q: this.q,
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                axios
                    .get('/api/salons', {params: {q, limit: 6}})
                    .then(response => this.salons = response.data.data)
            },
        },
        watch: {
            selected_ids(newValue, oldValue) {
                var addedIds = _.difference(newValue, oldValue)
                _.each(addedIds, id => {
                    var addedUser = _.find(this.salons, u => u.id === id)
                    if (addedUser) {
                        this.selected_salons.push(addedUser)
                    }
                })

                var removedIds = _.difference(oldValue, newValue)
                _.each(removedIds, id => {
                    this.selected_salons = _.filter(this.selected_salons, u => u.id !== id)
                })
            },
        },
    }
</script>

<style lang="less">
    @import "../../less/_boot";

    .select-salons {
        border: 0;
        background-color: #fff;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
        .panel-search {
            background-color: @gray-lightest;
        }
        label {
            margin-left: 3px;
        }
    }
    .selected-salons {
        line-height: 21px;
        font-size: 18px;
        text-align: left;
        color: #555555;
        margin: 23px;
    }
    .input-group-block {
        float: left;
        input.group-name {
            width: 250px;
            height: 34px;
            border-radius: 4px;
            background-color: #ffffff;
            border: solid 1px #dddddd;
            font-size: 14px;
            line-height: 1;
            letter-spacing: 0.5px;
            color: #3a3d3f;
            margin: 0 8px 0 23px;
            padding: 5px 11px;
        }
    }
</style>



// WEBPACK FOOTER //
// SelectSalons.vue?7691b37b